import { Check, Building2, Route, TreePine, Volume2 } from "lucide-react";
import { WHY_CHOOSE } from "@/mock";

const HIGHLIGHTS = [
  { icon: Building2, label: "BIEC", value: "~4 km", note: "Exhibitions & expos" },
  { icon: Route, label: "NICE Road", value: "Quick Exit", note: "Mysore in 2.5 hrs" },
  { icon: TreePine, label: "Residential", value: "Calm Lane", note: "Family-friendly" },
  { icon: Volume2, label: "Low Noise", value: "Peaceful", note: "Sleep deeply" },
];

const WhyChoose = () => {
  return (
    <section className="py-20 md:py-28 px-5 md:px-10 bg-[#F9F7F3]" data-testid="why-choose-section">
      <div className="max-w-6xl mx-auto">
        {/* 4 highlight badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-16">
          {HIGHLIGHTS.map((h, i) => (
            <div
              key={h.label}
              className="bg-white border border-[#E5E0D8] rounded-[18px] p-5 flex items-center gap-4 hover:border-[#C8A97E]/40 hover:-translate-y-0.5 transition-all"
              data-testid={`highlight-${h.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              <div className="w-12 h-12 rounded-[12px] bg-[#1A1A1A] flex items-center justify-center flex-shrink-0">
                <h.icon className="w-5 h-5 text-[#C8A97E]" strokeWidth={1.5} />
              </div>
              <div>
                <div className="text-[10px] tracking-[0.18em] uppercase text-[#9A9A9A] font-semibold">
                  {h.label}
                </div>
                <div className="font-serif text-[18px] font-semibold text-[#1A1A1A] leading-tight mt-0.5">
                  {h.value}
                </div>
                <div className="text-[11px] text-[#666] mt-0.5">{h.note}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <div className="text-[10px] tracking-[0.28em] uppercase text-[#C8A97E] font-semibold mb-3">
              Our Promise
            </div>
            <h2 className="font-serif text-[40px] sm:text-[46px] font-semibold text-[#1A1A1A] leading-[1.1] mb-5">
              Living Made <em className="text-[#C8A97E] font-normal">Effortless</em>
            </h2>
            <p className="text-[15px] text-[#555] leading-[1.85] mb-7">
              Hitha Residency is designed for business travellers attending events at <strong className="text-[#1A1A1A]">BIEC</strong>, families wanting calm and connectivity, and travellers headed out via <strong className="text-[#1A1A1A]">NICE Road</strong>. Tucked into a peaceful residential layout near Prestige Jindal, just 1 km from Chikkabidarakallu Metro — fully serviced rooms from single to spacious 3 BHK.
            </p>
            <ul className="space-y-3">
              {WHY_CHOOSE.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-[14px] text-[#555]" data-testid={`why-${i}`}>
                  <span className="w-5 h-5 rounded-full bg-[#C8A97E] flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check className="w-3 h-3 text-[#1A1A1A]" strokeWidth={3} />
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2 bg-[#1A1A1A] rounded-[20px] p-8 border border-[#C8A97E]/20 relative overflow-hidden">
            <div className="absolute -bottom-12 -right-12 w-48 h-48 rounded-full bg-[#C8A97E]/6 pointer-events-none" />
            <div className="font-serif text-[26px] sm:text-[30px] font-semibold text-[#C8A97E] leading-tight mb-3">
              Comfort · Convenience · Luxury
            </div>
            <div className="text-[13px] text-white/60">
              The Hitha Residency promise — every single day
            </div>
          </div>
          <StatCard num="6" label="Room types to choose from" />
          <StatCard num="10+" label="World-class facilities included" />
        </div>
        </div>
      </div>
    </section>
  );
};

const StatCard = ({ num, label }) => (
  <div className="bg-[#1A1A1A] rounded-[20px] p-7 border border-[#C8A97E]/20">
    <div className="font-serif text-[40px] font-semibold text-[#C8A97E] leading-none mb-2">
      {num}
    </div>
    <div className="text-[12px] text-white/55 leading-relaxed">{label}</div>
  </div>
);

export default WhyChoose;
